export default {
  // setFilterService4Spu(state, data) {
  //     state.filterService4Spu = data
  // },
  // setFilterArea4Spu(state, data) {
  //     state.filterArea4Spu = data
  // },
  // setServiceCateList(state, data) {
  //     state.serviceCateList = data
  // }
  setFilterSelfSelf(state, data) {
    state.filterSelf = data
  },
  setBusinessList(state, data) {
    state.businessList = data
  },
  setFilterBusiness(state, data) {
    state.filterBusiness = data
  }
}
